import { Plus, Trash2 } from "lucide-react";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { ControlledUnifiedInput } from "@/components/ui/customs/controlled-unified-input";
import { ExpeditionBoDeliveryInfoFormData } from "@/types/forms/bo/expeditionBo.form";

export const ClientAdditionalInfo = () => {
  const { t } = useTranslation("boExpeditionForm");
  const { control, setValue } = useFormContext<ExpeditionBoDeliveryInfoFormData>();

  const items = useWatch({ control, name: "deliveryInfo.clientAdditionalInfo" }) ?? [];

  const append = () =>
    setValue("deliveryInfo.clientAdditionalInfo", [...items, ""], { shouldDirty: true });

  const remove = (index: number) =>
    setValue(
      "deliveryInfo.clientAdditionalInfo",
      items.filter((_, i) => i !== index),
      { shouldDirty: true },
    );

  if (items.length === 0) {
    return (
      <Button className="w-fit" variant="outline" type="button" onClick={() => append()}>
        <Plus className="h-4 w-4" />
        {t("clientAdditionalInfo.addInfo")}
      </Button>
    );
  }

  return (
    <div className="flex flex-col gap-2 rounded-lg bg-slate-200 p-2">
      {items.map((_item, index) => (
        <div key={index} className="flex flex-row items-center gap-2">
          <ControlledUnifiedInput
            control={control}
            name={`deliveryInfo.clientAdditionalInfo.${index}`}
            placeholder={t("clientAdditionalInfo.linePlaceholder")}
            wrapperClassName="flex-1"
          />
          {items.length > 1 && (
            <Button variant="outline" type="button" onClick={() => remove(index)}>
              <Trash2 className="h-4 w-4" />
            </Button>
          )}
        </div>
      ))}
      <p className="text-sm text-gray-500">{t("clientAdditionalInfo.help")}</p>
      <Button className="w-fit" variant="outline" type="button" onClick={() => append()}>
        <Plus className="h-4 w-4" />
        {t("clientAdditionalInfo.addLine")}
      </Button>
    </div>
  );
};
